<div class="spinner-container" *ngIf="isLoading$ | async">
  <mat-spinner></mat-spinner>
</div>
